/* React */
import { CSSProperties } from 'react'
import parse from 'html-react-parser'

/* Material */
import Container from '@mui/material/Container'
import Typo from '@mui/material/Typography'
import { Theme } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

/* Shop-Config */
import shopInfos from 'template/infos'
import { menuPageBuilderFooterSpacingDefaults } from 'src/shared/dbTypes/menuPageBuilder'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: 'var(--builder-footer-legal-bg, transparent)',
    },
    inner: {
      paddingTop: 'var(--builder-footer-legal-padding-top, 10px)',
      paddingBottom: 'var(--builder-footer-legal-padding-bottom, 10px)',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      '& a': {
        color: 'inherit',
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },
  })
)

interface Props {
  text?: string
  backgroundColor?: string
  textColor?: string
  paddingTop?: number
  paddingBottom?: number
}

const Copyright: React.FC<Props> = ({
  text,
  backgroundColor,
  textColor,
  paddingTop,
  paddingBottom,
}) => {
  const classes = useStyles()
  const rootStyle = {
    ['--builder-footer-legal-bg' as string]: backgroundColor || undefined,
    ['--builder-footer-legal-padding-top' as string]: `${paddingTop ?? menuPageBuilderFooterSpacingDefaults.legalPaddingTop}px`,
    ['--builder-footer-legal-padding-bottom' as string]: `${paddingBottom ?? menuPageBuilderFooterSpacingDefaults.legalPaddingBottom}px`,
  } as CSSProperties

  return <div className={classes.root} style={rootStyle}>
    <Container maxWidth='lg' className={classes.inner}>
      <Typo variant='body2' align='center' style={{ color: textColor || undefined }}>
        {text ? parse(text) : `Copyright ©${shopInfos.publicher} ${new Date().getFullYear()}`}
      </Typo>
    </Container>
  </div>
}

export default Copyright
